"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var WizardStepDirective = /** @class */ (function () {
    function WizardStepDirective() {
        return {
            restrict: 'A',
            scope: {
                step: '@',
                stepDisplayName: '@'
            },
            require: '^wizard',
            link: function (scope, elem, attrs, ctrl) {
                var thisStep = {
                    step: scope.step,
                    stepDisplayName: scope.stepDisplayName,
                    isInvalid: function () {
                        return scope.$parent[scope.step].$invalid && scope.$parent[scope.step].$dirty;
                    },
                    isFormInvalid: function () {
                        return scope.$parent[scope.step].$invalid;
                    },
                    dirtify: function () {
                        var form = scope.$parent[scope.step];
                        form.$dirty = true;
                        angular.forEach(form, function (val, key) {
                            // if (!key.match(/\$/)) {
                            //     val.$dirty = true;
                            // }
                        });
                    }
                };
                ctrl.registerStep(thisStep);
                scope.isStepActive = (ctrl.activeStep != null) && (ctrl.activeStep.step === thisStep.step);
            }
        };
    }
    WizardStepDirective.create = function () {
        return new WizardStepDirective();
    };
    return WizardStepDirective;
}());
exports.WizardStepDirective = WizardStepDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2l6YXJkU3RlcC5kaXJlY3RpdmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ3aXphcmRTdGVwLmRpcmVjdGl2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlDQUFtQztBQUVuQztJQUVJO1FBQ0ksT0FBTztZQUNILFFBQVEsRUFBRSxHQUFHO1lBQ2IsS0FBSyxFQUFFO2dCQUNILElBQUksRUFBRSxHQUFHO2dCQUNULGVBQWUsRUFBRSxHQUFHO2FBQ3ZCO1lBQ0QsT0FBTyxFQUFFLFNBQVM7WUFDbEIsSUFBSSxFQUFFLFVBQVUsS0FBSyxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsSUFBSTtnQkFDcEMsSUFBSSxRQUFRLEdBQUc7b0JBQ1gsSUFBSSxFQUFFLEtBQUssQ0FBQyxJQUFJO29CQUNoQixlQUFlLEVBQUUsS0FBSyxDQUFDLGVBQWU7b0JBQ3RDLFNBQVMsRUFBRTt3QkFDUCxPQUFPLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLFFBQVEsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUM7b0JBQ2xGLENBQUM7b0JBQ0QsYUFBYSxFQUFFO3dCQUNYLE9BQU8sS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsUUFBUSxDQUFDO29CQUM5QyxDQUFDO29CQUNELE9BQU8sRUFBRTt3QkFDTCxJQUFJLElBQUksR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQzt3QkFDckMsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUM7d0JBQ25CLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLFVBQVUsR0FBRyxFQUFFLEdBQUc7NEJBQ3BDLDBCQUEwQjs0QkFDMUIseUJBQXlCOzRCQUN6QixJQUFJO3dCQUNSLENBQUMsQ0FBQyxDQUFDO29CQUVQLENBQUM7aUJBQ0osQ0FBQTtnQkFFRCxJQUFJLENBQUMsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDO2dCQUU1QixLQUFLLENBQUMsWUFBWSxHQUFHLENBQUMsSUFBSSxDQUFDLFVBQVUsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxLQUFLLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUUvRixDQUFDO1NBQ0osQ0FBQTtJQUVMLENBQUM7SUFFTSwwQkFBTSxHQUFiO1FBQ0ksT0FBTyxJQUFJLG1CQUFtQixFQUFFLENBQUM7SUFDckMsQ0FBQztJQUNMLDBCQUFDO0FBQUQsQ0FBQyxBQTVDRCxJQTRDQztBQTVDWSxrREFBbUIifQ==